module.exports = __webpack_public_path__ + "static/media/ico-tarjeta_0004_visa.8498a2ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imagenes/checkout/payment-options/ico-tarjeta_0004_visa.jpg
// module id = 124
// module chunks = 0